import React from 'react'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import ListItemText from '@mui/material/ListItemText'
import Select from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'
import { CircularProgress } from '@mui/material'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

export default function MultiSelectUsers ({
  label,
  options,
  onChange,
  selectedValues
}) {
  return (
    <FormControl sx={{ m: 1, width: 300 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={selectedValues}
        onChange={e => onChange(e.target.value)}
        input={<OutlinedInput label={label} />}
        renderValue={selected => {
          return selected.map(
            (option, i) => (i === 0 ? '' : ', ') + option?.firstname
          )
        }}
        MenuProps={MenuProps}
      >
        {options.map(option => (
          <MenuItem key={option.id} value={option}>
            <Checkbox checked={selectedValues.includes(option)} />
            <ListItemText primary={`${option.firstname} ${option.lastname}`} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
